<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { BaseTextArea } from '@cplug/design-system/components'

const modelValue = defineModel<string>({ required: true })

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col gap-2">
    <p class="body-small-regular">
      {{ t('FeedbackMessage') }}
    </p>
    <BaseTextArea v-model="modelValue" :placeholder="t('FeedbackPlaceholder')" :max="300" />
  </div>
</template>

<i18n lang="yaml">
pt-br:
  FeedbackMessage: 'Nos conte o motivo de estar voltando para a versão anterior. Sua opinião é essencial para que possamos melhorar continuamente!'
  FeedbackPlaceholder: 'Digite aqui'
</i18n>
